import moment from "moment";
import React from "react";
import { useSelector } from "react-redux";

const Summary = () => {
  const { summaryData } = useSelector((state) => state.home);
  return (
    <div className="summaryContainer">
      {summaryData.map((item, index) => {
        return <SummaryCard key={index} data={item} />;
      })}
    </div>
  );
};

const SummaryCard = ({ data }) => {
  return (
    <div className="summaryCard">
      <p>{data.title}</p>
      <p>{data.subTitle}</p>
      <div className="dateAndTag">
        <p>Due: {moment(data.dueDate).format("DD-MM-YYYY")}</p>
        <span className={`statusTag ${data.status}`}>{data.status}</span>
      </div>
    </div>
  );
};

export default Summary;
